import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';
import {
    CartStep1Interface,
    CartStep1ResponseInterface,
} from '../models/cart-step1.model';
import { CartStep1Repository } from '../repositories/cart-step1.repository';

export class sendCartStep1UseCase
    implements UseCase<CartStep1Interface, CartStep1ResponseInterface>
{
    constructor(private readonly repository: CartStep1Repository) {}

    execute(array: CartStep1Interface): Observable<CartStep1ResponseInterface> {
        return this.repository.sendCartStep1(array);
    }
}
